module.exports = __webpack_public_path__ + "static/media/zheng1-4@2x.a2427575.png";